import * as React from "react";
import AdminApprovalAgeView from "./components/AdminApprovalAge";

export default function AdminAgeApprovalViewPage() {
    return (
    <>
      <AdminApprovalAgeView />
    </>
  );
}